"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _icons = require("../icons");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var BreadCrumbs = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(BreadCrumbs, _React$PureComponent);
  var _super = _createSuper(BreadCrumbs);
  function BreadCrumbs() {
    (0, _classCallCheck2["default"])(this, BreadCrumbs);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(BreadCrumbs, [{
    key: "renderBreadCrumb",
    value: function renderBreadCrumb(link, idx, linkCount) {
      var isCurrentPageLink = idx === linkCount - 1;

      // eslint-disable-next-line no-use-before-define
      var LinkComponent = link.url ? Link : PlaceholderLink;
      var props = {};
      if (link.url) {
        props.href = link.url;
      }
      if (isCurrentPageLink) {
        props['aria-current'] = 'page';
      }
      return /*#__PURE__*/React.createElement(BreadCrumb, {
        key: idx
      }, /*#__PURE__*/React.createElement(LinkComponent, props, link.label), !isCurrentPageLink && /*#__PURE__*/React.createElement(ChevronSpacer, null, /*#__PURE__*/React.createElement(_icons.ForwardArrow, {
        width: "12px",
        color: _constants.colors.mediumGrey
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        links = _this$props.links,
        className = _this$props.className;
      var breadCrumbElems = links.map(function (link, idx) {
        return _this.renderBreadCrumb(link, idx, links.length);
      });
      return /*#__PURE__*/React.createElement("nav", {
        "aria-label": "Breadcrumb",
        className: className
      }, /*#__PURE__*/React.createElement(BreadCrumbList, null, breadCrumbElems));
    }
  }]);
  return BreadCrumbs;
}(React.PureComponent);
var _default = BreadCrumbs;
exports["default"] = _default;
var BreadCrumbList = _styledComponents["default"].ol.withConfig({
  displayName: "breadcrumbs__BreadCrumbList"
})(["list-style:none;display:inline-block;"]);
var BreadCrumb = _styledComponents["default"].li.withConfig({
  displayName: "breadcrumbs__BreadCrumb"
})(["display:inline-block;"]);
var Link = _styledComponents["default"].a.withConfig({
  displayName: "breadcrumbs__Link"
})(["&:hover{text-decoration:none;}"]);
var ChevronSpacer = _styledComponents["default"].div.withConfig({
  displayName: "breadcrumbs__ChevronSpacer"
})(["display:inline-block;vertical-align:middle;padding:0 5px;"]);
var PlaceholderLink = (0, _styledComponents["default"])(Link).withConfig({
  displayName: "breadcrumbs__PlaceholderLink"
})(["color:", ";"], _constants.colors.mediumGrey);